import { render, staticRenderFns } from "./Ptsp.vue?vue&type=template&id=57a77e8c"
import script from "./Ptsp.vue?vue&type=script&lang=js"
export * from "./Ptsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports